import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const useStyles = makeStyles((theme) => ({
  withErrors: {
    marginBottom: 340
  },
  container: {
    marginBottom: 120
  },
  pageContainer: {
    position: 'relative'
  },
  recalculatingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 100,
    cursor: 'wait',
    backgroundColor: theme.colorPalette.beige_50_op_50,
    // Reskin: one light white layer over the whole page rather than a beige box over the main column.
    ...reskinStyles(theme, { position: 'fixed', backgroundColor: theme.colorPalette.white_op_30 })
  },
  // fixed so the spinner sits mid-viewport wherever the agent has scrolled
  recalculatingLoader: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    marginTop: -24,
    marginLeft: -24,
    color: theme.palette.secondary.main
  },
  loaderContainer: {
    marginTop: 32,
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 32,
    minHeight: 600
  },
  loader: {
    color: theme.palette.secondary.main
  },
  tab: {
    fontSize: 14,
    textTransform: 'uppercase',
    fontWeight: 'bold'
  },
  cardLoadingContainer: {
    width: '100%',
    marginTop: 16,
    backgroundColor: theme.colorPalette.green_90,
    '&> div': {
      borderTop: `1px solid ${theme.onCardDivider.beige_25_op_30} `
    },
    '&> div:first-child': {
      borderTop: 'none'
    },
    marginBottom: 16,
    ...reskinStyles(theme, theme.cardStyles.outlined)
  }
}));

export default useStyles;
